/**
 * @generated SignedSource<<fe2de9e6041ac0a59f55aa0d4c4431c3>>
 * @relayHash daf66e46013fda4b2d21c36fa6645fde
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 52d196a78321980ee93aa1e09c273bb43c438b4246d2927977ec6ac8b55b2948

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RuleListQuery$variables = {
  cloudId: string;
  first: number;
  projectKey: string;
};
export type RuleListQuery$data = {
  readonly jira: {
    readonly jiraProjectByKey: {
      readonly conditionalFormattingRules: {
        readonly __id: string;
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly expression: {
              readonly fieldId?: string;
            };
            readonly id: string;
            readonly " $fragmentSpreads": FragmentRefs<"RuleItem_formatting_rule">;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly key: string;
    };
  };
};
export type RuleListQuery = {
  response: RuleListQuery$data;
  variables: RuleListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "key"
},
v5 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v8 = [
  (v7/*: any*/)
],
v9 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "RuleListQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v3/*: any*/),
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "jiraProjectByKey",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "args": (v5/*: any*/),
                    "concreteType": "JiraFormattingRuleConnection",
                    "kind": "LinkedField",
                    "name": "conditionalFormattingRules",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraFormattingRuleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraFormattingRule",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "expression",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v8/*: any*/),
                                    "type": "JiraFormattingMultipleValueOperand"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v8/*: any*/),
                                    "type": "JiraFormattingSingleValueOperand"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v8/*: any*/),
                                    "type": "JiraFormattingNoValueOperand"
                                  }
                                ]
                              },
                              {
                                "kind": "FragmentSpread",
                                "name": "RuleItem_formatting_rule"
                              }
                            ]
                          }
                        ]
                      },
                      (v9/*: any*/)
                    ]
                  }
                ]
              },
              "action": "THROW",
              "path": "jira.jiraProjectByKey"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RuleListQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "args": (v5/*: any*/),
                "concreteType": "JiraFormattingRuleConnection",
                "kind": "LinkedField",
                "name": "conditionalFormattingRules",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFormattingRuleEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraFormattingRule",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "expression",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "__typename"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "alias": "multipleValueOperator",
                                    "kind": "ScalarField",
                                    "name": "operator"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "values"
                                  }
                                ],
                                "type": "JiraFormattingMultipleValueOperand"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "alias": "singleValueOperator",
                                    "kind": "ScalarField",
                                    "name": "operator"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "value"
                                  }
                                ],
                                "type": "JiraFormattingSingleValueOperand"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "alias": "noValueOperator",
                                    "kind": "ScalarField",
                                    "name": "operator"
                                  }
                                ],
                                "type": "JiraFormattingNoValueOperand"
                              }
                            ]
                          },
                          {
                            "concreteType": "JiraColor",
                            "kind": "LinkedField",
                            "name": "formattingColor",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "colorKey"
                              },
                              (v6/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "formattingArea"
                          }
                        ]
                      }
                    ]
                  },
                  (v9/*: any*/)
                ]
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "52d196a78321980ee93aa1e09c273bb43c438b4246d2927977ec6ac8b55b2948",
    "metadata": {},
    "name": "RuleListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4d83b6dcddd13e5dd174c74a42515190";

export default node;
